module.exports = __webpack_public_path__ + "img/Monte_Kope_8.1cfc4d3f.jpg";